import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M11.006 14l-6-6V2h6v6z" style={{
      marker: "none"
    }} color="#000" overflow="visible" fill="#2e3436" /></svg>;
}

export default SvgComponent;